module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 18);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t) {
  e.exports = require("prop-types");
}, function (e, t, n) {
  var r = n(14);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(5)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, t) {
  e.exports = require("classnames");
}, function (e, t) {
  e.exports = function (e) {
    var t = [];
    return t.toString = function () {
      return this.map(function (t) {
        var n = function (e, t) {
          var n = e[1] || "",
              r = e[3];
          if (!r) return n;

          if (t && "function" == typeof btoa) {
            var o = (a = r, "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(a)))) + " */"),
                i = r.sources.map(function (e) {
              return "/*# sourceURL=" + r.sourceRoot + e + " */";
            });
            return [n].concat(i).concat([o]).join("\n");
          }

          var a;
          return [n].join("\n");
        }(t, e);

        return t[2] ? "@media " + t[2] + "{" + n + "}" : n;
      }).join("");
    }, t.i = function (e, n) {
      "string" == typeof e && (e = [[null, e, ""]]);

      for (var r = {}, o = 0; o < this.length; o++) {
        var i = this[o][0];
        "number" == typeof i && (r[i] = !0);
      }

      for (o = 0; o < e.length; o++) {
        var a = e[o];
        "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), t.push(a));
      }
    }, t;
  };
}, function (e, t, n) {
  var r,
      o,
      i = {},
      a = (r = function r() {
    return window && document && document.all && !window.atob;
  }, function () {
    return void 0 === o && (o = r.apply(this, arguments)), o;
  }),
      c = function c(e, t) {
    return t ? t.querySelector(e) : document.querySelector(e);
  },
      s = function (e) {
    var t = {};
    return function (e, n) {
      if ("function" == typeof e) return e();

      if (void 0 === t[e]) {
        var r = c.call(this, e, n);
        if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
          r = r.contentDocument.head;
        } catch (e) {
          r = null;
        }
        t[e] = r;
      }

      return t[e];
    };
  }(),
      u = null,
      l = 0,
      f = [],
      p = n(13);

  function b(e, t) {
    for (var n = 0; n < e.length; n++) {
      var r = e[n],
          o = i[r.id];

      if (o) {
        o.refs++;

        for (var a = 0; a < o.parts.length; a++) {
          o.parts[a](r.parts[a]);
        }

        for (; a < r.parts.length; a++) {
          o.parts.push(v(r.parts[a], t));
        }
      } else {
        var c = [];

        for (a = 0; a < r.parts.length; a++) {
          c.push(v(r.parts[a], t));
        }

        i[r.id] = {
          id: r.id,
          refs: 1,
          parts: c
        };
      }
    }
  }

  function m(e, t) {
    for (var n = [], r = {}, o = 0; o < e.length; o++) {
      var i = e[o],
          a = t.base ? i[0] + t.base : i[0],
          c = {
        css: i[1],
        media: i[2],
        sourceMap: i[3]
      };
      r[a] ? r[a].parts.push(c) : n.push(r[a] = {
        id: a,
        parts: [c]
      });
    }

    return n;
  }

  function y(e, t) {
    var n = s(e.insertInto);
    if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
    var r = f[f.length - 1];
    if ("top" === e.insertAt) r ? r.nextSibling ? n.insertBefore(t, r.nextSibling) : n.appendChild(t) : n.insertBefore(t, n.firstChild), f.push(t);else if ("bottom" === e.insertAt) n.appendChild(t);else {
      if ("object" != typeof e.insertAt || !e.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
      var o = s(e.insertAt.before, n);
      n.insertBefore(t, o);
    }
  }

  function d(e) {
    if (null === e.parentNode) return !1;
    e.parentNode.removeChild(e);
    var t = f.indexOf(e);
    t >= 0 && f.splice(t, 1);
  }

  function h(e) {
    var t = document.createElement("style");

    if (void 0 === e.attrs.type && (e.attrs.type = "text/css"), void 0 === e.attrs.nonce) {
      var r = function () {
        0;
        return n.nc;
      }();

      r && (e.attrs.nonce = r);
    }

    return g(t, e.attrs), y(e, t), t;
  }

  function g(e, t) {
    Object.keys(t).forEach(function (n) {
      e.setAttribute(n, t[n]);
    });
  }

  function v(e, t) {
    var n, r, o, i;

    if (t.transform && e.css) {
      if (!(i = "function" == typeof t.transform ? t.transform(e.css) : t.transform.default(e.css))) return function () {};
      e.css = i;
    }

    if (t.singleton) {
      var a = l++;
      n = u || (u = h(t)), r = O.bind(null, n, a, !1), o = O.bind(null, n, a, !0);
    } else e.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = function (e) {
      var t = document.createElement("link");
      return void 0 === e.attrs.type && (e.attrs.type = "text/css"), e.attrs.rel = "stylesheet", g(t, e.attrs), y(e, t), t;
    }(t), r = k.bind(null, n, t), o = function o() {
      d(n), n.href && URL.revokeObjectURL(n.href);
    }) : (n = h(t), r = z.bind(null, n), o = function o() {
      d(n);
    });

    return r(e), function (t) {
      if (t) {
        if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
        r(e = t);
      } else o();
    };
  }

  e.exports = function (e, t) {
    if ("undefined" != typeof DEBUG && DEBUG && "object" != typeof document) throw new Error("The style-loader cannot be used in a non-browser environment");
    (t = t || {}).attrs = "object" == typeof t.attrs ? t.attrs : {}, t.singleton || "boolean" == typeof t.singleton || (t.singleton = a()), t.insertInto || (t.insertInto = "head"), t.insertAt || (t.insertAt = "bottom");
    var n = m(e, t);
    return b(n, t), function (e) {
      for (var r = [], o = 0; o < n.length; o++) {
        var a = n[o];
        (c = i[a.id]).refs--, r.push(c);
      }

      e && b(m(e, t), t);

      for (o = 0; o < r.length; o++) {
        var c;

        if (0 === (c = r[o]).refs) {
          for (var s = 0; s < c.parts.length; s++) {
            c.parts[s]();
          }

          delete i[c.id];
        }
      }
    };
  };

  var w,
      _ = (w = [], function (e, t) {
    return w[e] = t, w.filter(Boolean).join("\n");
  });

  function O(e, t, n, r) {
    var o = n ? "" : r.css;
    if (e.styleSheet) e.styleSheet.cssText = _(t, o);else {
      var i = document.createTextNode(o),
          a = e.childNodes;
      a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(i, a[t]) : e.appendChild(i);
    }
  }

  function z(e, t) {
    var n = t.css,
        r = t.media;
    if (r && e.setAttribute("media", r), e.styleSheet) e.styleSheet.cssText = n;else {
      for (; e.firstChild;) {
        e.removeChild(e.firstChild);
      }

      e.appendChild(document.createTextNode(n));
    }
  }

  function k(e, t, n) {
    var r = n.css,
        o = n.sourceMap,
        i = void 0 === t.convertToAbsoluteUrls && o;
    (t.convertToAbsoluteUrls || i) && (r = p(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
    var a = new Blob([r], {
      type: "text/css"
    }),
        c = e.href;
    e.href = URL.createObjectURL(a), c && URL.revokeObjectURL(c);
  }
}, function (e, t, n) {
  var r = n(16);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(5)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, t) {
  e.exports = require("react-dom");
}, function (e, t, n) {
  var r = n(15);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(5)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, t) {
  e.exports = require("lodash.memoize");
}, function (e, t, n) {
  var r = n(12);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(5)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, t, n) {
  var r = n(17);
  "string" == typeof r && (r = [[e.i, r, ""]]);
  var o = {
    hmr: !0,
    transform: void 0,
    insertInto: void 0
  };
  n(5)(r, o);
  r.locals && (e.exports = r.locals);
}, function (e, t, n) {
  (t = e.exports = n(4)(!1)).push([e.i, ".wrapperLayer__z_PKn {\n  position: fixed;\n  margin: 0;\n  padding: 0;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 999;\n}\n", ""]), t.locals = {
    wrapperLayer: "wrapperLayer__z_PKn"
  };
}, function (e, t) {
  e.exports = function (e) {
    var t = "undefined" != typeof window && window.location;
    if (!t) throw new Error("fixUrls requires window.location");
    if (!e || "string" != typeof e) return e;
    var n = t.protocol + "//" + t.host,
        r = n + t.pathname.replace(/\/[^\/]*$/, "/");
    return e.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (e, t) {
      var o,
          i = t.trim().replace(/^"(.*)"$/, function (e, t) {
        return t;
      }).replace(/^'(.*)'$/, function (e, t) {
        return t;
      });
      return /^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(i) ? e : (o = 0 === i.indexOf("//") ? i : 0 === i.indexOf("/") ? n + i : r + i.replace(/^\.\//, ""), "url(" + JSON.stringify(o) + ")");
    });
  };
}, function (e, t, n) {
  (t = e.exports = n(4)(!1)).push([e.i, "/* 与 anim.js 同步 */\n.baseButton__2AV5J {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n.baseButton__2AV5J > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu {\n  box-sizing: border-box;\n  position: absolute;\n  top: 0.6rem;\n  right: 0.6rem;\n  opacity: 0;\n  display: -webkit-box;\n  display: flex;\n  z-index: 1000;\n  border-radius: 5rem;\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n  -webkit-transition: opacity 350ms, -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms, -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms;\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms, -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu.show__2Pu4e {\n  opacity: 0.8;\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n}\n.controls__NTVNu .pinButton__pLhHH {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .pinButton__pLhHH > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .pinButton__pLhHH:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .pinButton__pLhHH:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .pinButton__pLhHH:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .pinButton__pLhHH:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .rotate__18SVA {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotate__18SVA > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .rotate__18SVA:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .rotate__18SVA:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .rotate__18SVA:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .rotate__18SVA:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .rotate__18SVA svg {\n  width: 1.75rem;\n  -webkit-transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateLeft__1y4kO {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateLeft__1y4kO > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .rotateLeft__1y4kO:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .rotateLeft__1y4kO:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .rotateLeft__1y4kO:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .rotateLeft__1y4kO:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .rotateLeft__1y4kO svg {\n  width: 1.75rem;\n  -webkit-transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateLeft__1y4kO:hover svg {\n  -webkit-transform: rotate(-30deg);\n          transform: rotate(-30deg);\n}\n.controls__NTVNu .rotateRight__1GeTD {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateRight__1GeTD > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .rotateRight__1GeTD:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .rotateRight__1GeTD:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .rotateRight__1GeTD:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .rotateRight__1GeTD:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .rotateRight__1GeTD svg {\n  width: 1.75rem;\n  -webkit-transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .rotateRight__1GeTD:hover svg {\n  -webkit-transform: rotate(30deg);\n          transform: rotate(30deg);\n}\n.controls__NTVNu .download__TnaVI {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .download__TnaVI > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .download__TnaVI:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .download__TnaVI:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .download__TnaVI:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .download__TnaVI:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .download__TnaVI svg {\n  margin-top: -0.06rem;\n  width: 1.75rem;\n}\n.controls__NTVNu .zoom__1W2_u {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .zoom__1W2_u > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .zoom__1W2_u:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .zoom__1W2_u:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .zoom__1W2_u:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .zoom__1W2_u:last-of-type {\n  margin-right: 0.4rem;\n}\n.controls__NTVNu .close__h79Tx {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  margin: 0.4em 0;\n  width: 2rem;\n  height: 2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.controls__NTVNu .close__h79Tx > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.controls__NTVNu .close__h79Tx:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.controls__NTVNu .close__h79Tx:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n.controls__NTVNu .close__h79Tx:first-of-type {\n  margin-left: 0.4rem;\n}\n.controls__NTVNu .close__h79Tx:last-of-type {\n  margin-right: 0.4rem;\n}\n.sideButton__25vo1 {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  padding: 0.4rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.sideButton__25vo1 > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.sideButton__25vo1:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: translateX(0) translateY(-50%) !important;\n          transform: translateX(0) translateY(-50%) !important;\n}\n.sideButton__25vo1:active {\n  opacity: 1 !important;\n}\n.sideButton__25vo1.show__2Pu4e {\n  opacity: 0.8;\n}\n.flipLeft__fhip_ {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  padding: 0.4rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  left: 0;\n  padding-left: 0.6rem;\n  border-radius: 0 0.5em 0.5em 0;\n  -webkit-transform: translateX(-100%) translateY(-50%);\n          transform: translateX(-100%) translateY(-50%);\n}\n.flipLeft__fhip_ > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.flipLeft__fhip_:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: translateX(0) translateY(-50%) !important;\n          transform: translateX(0) translateY(-50%) !important;\n}\n.flipLeft__fhip_:active {\n  opacity: 1 !important;\n}\n.flipLeft__fhip_.show__2Pu4e {\n  opacity: 0.8;\n}\n.flipLeft__fhip_:active {\n  -webkit-transform: translate(-0.2em) translateY(-50%) !important;\n          transform: translate(-0.2em) translateY(-50%) !important;\n}\n.flipLeft__fhip_.show__2Pu4e {\n  opacity: 0.8;\n  -webkit-transform: translate(-0.2em) translateY(-50%);\n          transform: translate(-0.2em) translateY(-50%);\n}\n.flipRight__2T92B {\n  z-index: 1000;\n  box-sizing: border-box;\n  cursor: pointer;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  padding: 0.4rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 175ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 175ms cubic-bezier(0.6, 0, 0.1, 1);\n  right: 0;\n  padding-right: 0.6rem;\n  border-radius: 0.5rem 0 0 0.5rem;\n  -webkit-transform: translateX(100%) translateY(-50%);\n          transform: translateX(100%) translateY(-50%);\n}\n.flipRight__2T92B > svg {\n  display: block;\n  width: 2rem;\n  height: 2rem;\n}\n.flipRight__2T92B:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: translateX(0) translateY(-50%) !important;\n          transform: translateX(0) translateY(-50%) !important;\n}\n.flipRight__2T92B:active {\n  opacity: 1 !important;\n}\n.flipRight__2T92B.show__2Pu4e {\n  opacity: 0.8;\n}\n.flipRight__2T92B:active {\n  -webkit-transform: translate(0.2em) translateY(-50%) !important;\n          transform: translate(0.2em) translateY(-50%) !important;\n}\n.flipRight__2T92B.show__2Pu4e {\n  opacity: 0.8;\n  -webkit-transform: translate(0.2em) translateY(-50%);\n          transform: translate(0.2em) translateY(-50%);\n}\n.pages__2jlej {\n  box-sizing: border-box;\n  display: -webkit-box;\n  display: flex;\n  position: absolute;\n  left: 50%;\n  bottom: 0.6rem;\n  z-index: 110;\n  opacity: 0;\n  border-radius: 2rem;\n  -webkit-transform: translate(-50%, 100px);\n          transform: translate(-50%, 100px);\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.pages__2jlej.show__2Pu4e {\n  opacity: 0.8;\n  -webkit-transform: translate(-50%, 0);\n          transform: translate(-50%, 0);\n}\n.pages__2jlej.mobile__3HB5p {\n  bottom: 2rem;\n}\n.pages__2jlej .dot__p50eg {\n  cursor: pointer;\n  margin: 0.45rem 0.25rem;\n  display: block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 1.2rem;\n  background: black;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.pages__2jlej .dot__p50eg:first-of-type {\n  margin-left: 0.6rem;\n}\n.pages__2jlej .dot__p50eg:last-of-type {\n  margin-right: 0.6rem;\n}\n.pages__2jlej .blackDot__TTF7k {\n  cursor: pointer;\n  margin: 0.45rem 0.25rem;\n  display: block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 1.2rem;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  cursor: initial;\n  width: 1rem;\n  background: black;\n}\n.pages__2jlej .blackDot__TTF7k:first-of-type {\n  margin-left: 0.6rem;\n}\n.pages__2jlej .blackDot__TTF7k:last-of-type {\n  margin-right: 0.6rem;\n}\n.pages__2jlej .whiteDot__3iAb5 {\n  cursor: pointer;\n  margin: 0.45rem 0.25rem;\n  display: block;\n  width: 0.6rem;\n  height: 0.6rem;\n  border-radius: 1.2rem;\n  background: black;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), width 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  background: #999;\n}\n.pages__2jlej .whiteDot__3iAb5:first-of-type {\n  margin-left: 0.6rem;\n}\n.pages__2jlej .whiteDot__3iAb5:last-of-type {\n  margin-right: 0.6rem;\n}\n.pages__2jlej .whiteDot__3iAb5:hover {\n  opacity: 0.8 !important;\n  -webkit-transform: scale(1.1) !important;\n          transform: scale(1.1) !important;\n}\n.pages__2jlej .whiteDot__3iAb5:active {\n  opacity: 1 !important;\n  -webkit-transform: scale(1) !important;\n          transform: scale(1) !important;\n}\n", ""]), t.locals = {
    baseButton: "baseButton__2AV5J",
    controls: "controls__NTVNu",
    show: "show__2Pu4e",
    pinButton: "pinButton__pLhHH",
    rotate: "rotate__18SVA",
    rotateLeft: "rotateLeft__1y4kO",
    rotateRight: "rotateRight__1GeTD",
    download: "download__TnaVI",
    zoom: "zoom__1W2_u",
    close: "close__h79Tx",
    sideButton: "sideButton__25vo1",
    flipLeft: "flipLeft__fhip_",
    flipRight: "flipRight__2T92B",
    pages: "pages__2jlej",
    mobile: "mobile__3HB5p",
    dot: "dot__p50eg",
    blackDot: "blackDot__TTF7k",
    whiteDot: "whiteDot__3iAb5"
  };
}, function (e, t, n) {
  (t = e.exports = n(4)(!1)).push([e.i, "/* 与 anim.js 同步 */\n.imageLayer__1NyU2 {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), opacity 350ms cubic-bezier(0.6, 0, 0.1, 1), clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-clip-path 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  will-change: transform, top, opacity, clip-path;\n}\n.imageLayer__1NyU2.zooming__3TFmo {\n  -webkit-transition-timing-function: cubic-bezier(0, 0.1, 0.1, 1);\n          transition-timing-function: cubic-bezier(0, 0.1, 0.1, 1);\n  -ms-transition-duration: 0ms;\n}\n.imageLayer__1NyU2.invalidate__1wygJ {\n  opacity: 0 !important;\n  pointer-events: none;\n}\n", ""]), t.locals = {
    imageLayer: "imageLayer__1NyU2",
    zooming: "zooming__3TFmo",
    invalidate: "invalidate__1wygJ"
  };
}, function (e, t, n) {
  (t = e.exports = n(4)(!1)).push([e.i, "/* 与 anim.js 同步 */\n.loadingContainer__33QBo {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  opacity: 0;\n  -webkit-transition: opacity cubic-bezier(0.6, 0, 0.1, 1) 175ms;\n  transition: opacity cubic-bezier(0.6, 0, 0.1, 1) 175ms;\n}\n.loadingContainer__33QBo.show__1Bu8R {\n  opacity: 1;\n}\n.loadingContainer__33QBo .reload__3KDuO {\n  border: 2px solid;\n  border-radius: 5px;\n  font-size: 1rem;\n  padding: 0.5rem;\n  cursor: pointer;\n  outline: none;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.loadingContainer__33QBo .reload__3KDuO:hover {\n  opacity: 0.8;\n}\n.loadingContainer__33QBo .reload__3KDuO:hover svg {\n  -webkit-transform: rotate(30deg);\n          transform: rotate(30deg);\n}\n.loadingContainer__33QBo .reload__3KDuO:active {\n  opacity: 1;\n}\n.loadingContainer__33QBo .reload__3KDuO svg {\n  display: block;\n  -webkit-transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n  transition: transform 350ms cubic-bezier(0.6, 0, 0.1, 1), -webkit-transform 350ms cubic-bezier(0.6, 0, 0.1, 1);\n}\n.loadingContainer__33QBo .loading__3UcNS {\n  width: 24px;\n  height: 24px;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-animation: spin__2VDbe 1s linear infinite;\n          animation: spin__2VDbe 1s linear infinite;\n}\n@-webkit-keyframes fadeIn__3TpcC {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@keyframes fadeIn__3TpcC {\n  0% {\n    opacity: 0;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n@-webkit-keyframes fadeOut__9PHOR {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@keyframes fadeOut__9PHOR {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0;\n  }\n}\n@-webkit-keyframes spin__2VDbe {\n  0% {\n    -webkit-transform: translate(-50%, -50%) rotate(0deg);\n            transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    -webkit-transform: translate(-50%, -50%) rotate(360deg);\n            transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n@keyframes spin__2VDbe {\n  0% {\n    -webkit-transform: translate(-50%, -50%) rotate(0deg);\n            transform: translate(-50%, -50%) rotate(0deg);\n  }\n  100% {\n    -webkit-transform: translate(-50%, -50%) rotate(360deg);\n            transform: translate(-50%, -50%) rotate(360deg);\n  }\n}\n", ""]), t.locals = {
    loadingContainer: "loadingContainer__33QBo",
    show: "show__1Bu8R",
    reload: "reload__3KDuO",
    loading: "loading__3UcNS",
    spin: "spin__2VDbe",
    fadeIn: "fadeIn__3TpcC",
    fadeOut: "fadeOut__9PHOR"
  };
}, function (e, t, n) {
  (t = e.exports = n(4)(!1)).push([e.i, "/* 与 anim.js 同步 */\n.backgroundLayer__36t43 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  cursor: -webkit-zoom-out;\n  cursor: zoom-out;\n  background-color: #ffffff;\n  -webkit-transition: opacity 0.2s;\n  transition: opacity 0.2s;\n  will-change: opacity;\n  -webkit-tap-highlight-color: transparent;\n}\n", ""]), t.locals = {
    backgroundLayer: "backgroundLayer__36t43"
  };
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(0),
      o = n.n(r),
      i = n(7),
      a = n.n(i),
      c = n(10),
      s = n.n(c),
      u = n(1),
      l = n.n(u);

  function f(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function p(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? f(Object(n), !0).forEach(function (t) {
        b(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function b(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var m = function m() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.set,
        n = e.src,
        r = e.alt,
        o = e.txt,
        i = e.restProps;
    return Array.isArray(t) && t.length > 0 ? t : [p({
      src: n,
      alt: r,
      txt: o
    }, i)];
  };

  function y(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function d(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function h(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? d(Object(n), !0).forEach(function (t) {
        g(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function g(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var v = {
    src: l.a.string,
    alt: l.a.string,
    txt: l.a.string,
    set: l.a.oneOfType([l.a.arrayOf(l.a.shape({
      src: l.a.string,
      alt: l.a.string,
      text: l.a.string
    })), l.a.shape({
      src: l.a.string,
      alt: l.a.string,
      text: l.a.string
    })]),
    defaultPage: l.a.number,
    preset: l.a.oneOf(["", "desktop", "mobile"]),
    controller: l.a.oneOfType([l.a.bool, l.a.shape({
      pagination: l.a.bool,
      rotate: l.a.bool,
      zoom: l.a.bool,
      download: l.a.bool,
      close: l.a.bool,
      flip: l.a.bool
    })]),
    hotKey: l.a.oneOfType([l.a.bool, l.a.shape({
      close: l.a.bool,
      zoom: l.a.bool,
      flip: l.a.bool
    })]),
    animate: l.a.shape({
      browsing: l.a.bool,
      flip: l.a.oneOf(["fade", "crossFade", "swipe", "zoom"])
    }),
    hideOnScroll: l.a.bool,
    coverVisible: l.a.bool,
    backdrop: l.a.string,
    zIndex: l.a.number,
    radius: l.a.number,
    edge: l.a.number,
    loop: l.a.bool,
    onBrowsing: l.a.func,
    onZooming: l.a.func,
    onSwitching: l.a.func,
    onRotating: l.a.func,
    browsing: l.a.bool
  },
      w = {
    src: "",
    alt: "",
    txt: "",
    set: [],
    defaultPage: 0,
    preset: "",
    controller: {},
    hotKey: {},
    animate: {},
    hideOnScroll: !0,
    coverVisible: !1,
    backdrop: "#FFFFFF",
    zIndex: 1e3,
    radius: 0,
    edge: 0,
    loop: !0,
    onBrowsing: function onBrowsing() {},
    onZooming: function onZooming() {},
    onSwitching: function onSwitching() {},
    onRotating: function onRotating() {}
  },
      _ = {
    controller: {
      pagination: !0,
      rotate: !1,
      zoom: !1,
      download: !1,
      close: !0,
      flip: !1
    },
    hotKey: {
      close: !1,
      zoom: !1,
      flip: !1
    },
    animate: {
      browsing: !0,
      flip: "swipe"
    }
  },
      O = !1,
      z = h({}, w, {}, {
    controller: {
      pagination: !0,
      rotate: !0,
      zoom: !0,
      download: !1,
      close: !0,
      flip: !0
    },
    hotKey: {
      close: !0,
      zoom: !0,
      flip: !0
    },
    animate: {
      browsing: !0,
      flip: "fade"
    }
  }),
      k = h({}, w, {}, _),
      j = function j(e) {
    switch (e) {
      case "desktop":
        return z;

      case "mobile":
        return k;

      case "auto":
        return O || (console.warn("Zmage: The value 'auto' for the props 'preset' has been deprecated, replace with one of 'Desktop' or 'Mobile', the value 'auto' will be fallback to 'desktop'"), O = !0), z;

      default:
        return z;
    }
  },
      P = function P(e) {
    var t = e.className,
        n = e.style,
        r = e.onClick,
        o = e.forwardedRef,
        i = e.coverRef,
        a = e.destroyer,
        c = e.src,
        s = e.alt,
        u = e.txt,
        l = e.set,
        f = e.defaultPage,
        p = e.preset,
        b = e.controller,
        d = e.hotKey,
        h = e.animate,
        g = e.hideOnScroll,
        v = e.coverVisible,
        w = e.backdrop,
        _ = e.zIndex,
        O = e.radius,
        z = e.edge,
        k = e.loop,
        j = e.onBrowsing,
        P = e.onZooming,
        x = e.onSwitching,
        S = e.onRotating,
        E = e.browsing,
        T = y(e, ["className", "style", "onClick", "forwardedRef", "coverRef", "destroyer", "src", "alt", "txt", "set", "defaultPage", "preset", "controller", "hotKey", "animate", "hideOnScroll", "coverVisible", "backdrop", "zIndex", "radius", "edge", "loop", "onBrowsing", "onZooming", "onSwitching", "onRotating", "browsing"]);
    return {
      coverProps: {
        className: t,
        style: n,
        onClick: r,
        forwardedRef: o,
        src: c,
        alt: s,
        txt: u
      },
      calleeProps: {
        coverRef: i,
        destroyer: a
      },
      stateProps: {
        controlledBrowsing: E
      },
      configProps: {
        defaultPage: f,
        set: m({
          set: l,
          src: c,
          alt: s,
          txt: u
        }),
        preset: p,
        controller: b,
        hotKey: d,
        animate: h,
        hideOnScroll: g,
        coverVisible: v,
        backdrop: w,
        zIndex: _,
        radius: O,
        edge: z,
        loop: k,
        onBrowsing: j,
        onZooming: P,
        onSwitching: x,
        onRotating: S
      },
      restProps: T
    };
  };

  function x(e) {
    return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function S(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function E(e, t) {
    return !t || "object" !== x(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function T(e) {
    return (T = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function N(e, t) {
    return (N = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var C = function (e) {
    function t(e) {
      var n;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), (n = E(this, T(t).call(this, e))).target = e.target || document.body, n.container = document.createElement("figure"), n.container.id = e.id, n.container.className = e.className, n.container.style.zIndex = e.zIndex, n.target.appendChild(n.container), n;
    }

    var n, r, o;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && N(e, t);
    }(t, e), n = t, (r = [{
      key: "componentWillUnmount",
      value: function value() {
        this.target.removeChild(this.container);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.children;
        return a.a.createPortal(e, this.container);
      }
    }]) && S(n.prototype, r), o && S(n, o), t;
  }(o.a.PureComponent);

  C.defaultProps = {
    zIndex: w.zIndex
  }, C.propTypes = {
    id: l.a.string,
    className: l.a.string,
    zIndex: v.zIndex
  };
  var I = n(3),
      R = n.n(I),
      L = n(2),
      D = n.n(L);

  function V(e) {
    return (V = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function B(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function M(e, t) {
    return !t || "object" !== V(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function A(e) {
    return (A = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function W(e, t) {
    return (W = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var F = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), M(this, A(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && W(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          d: "M14.71 15.88L10.83 12l3.88-3.88c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L8.71 11.3c-.39.39-.39 1.02 0 1.41l4.59 4.59c.39.39 1.02.39 1.41 0 .38-.39.39-1.03 0-1.42z"
        }));
      }
    }]) && B(n.prototype, r), i && B(n, i), t;
  }(o.a.PureComponent);

  function G(e) {
    return (G = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function H(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function U(e, t) {
    return !t || "object" !== G(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function Y(e) {
    return (Y = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function K(e, t) {
    return (K = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var Z = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), U(this, Y(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && K(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          d: "M9.29 15.88L13.17 12 9.29 8.12c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0l4.59 4.59c.39.39.39 1.02 0 1.41L10.7 17.3c-.39.39-1.02.39-1.41 0-.38-.39-.39-1.03 0-1.42z"
        }));
      }
    }]) && H(n.prototype, r), i && H(n, i), t;
  }(o.a.PureComponent);

  function X(e) {
    return (X = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function q(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Q(e, t) {
    return !t || "object" !== X(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function J(e) {
    return (J = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function $(e, t) {
    return ($ = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var ee = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), Q(this, J(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && $(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
        }));
      }
    }]) && q(n.prototype, r), i && q(n, i), t;
  }(o.a.PureComponent);

  function te(e) {
    return (te = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function ne(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function re(e, t) {
    return !t || "object" !== te(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function oe(e) {
    return (oe = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function ie(e, t) {
    return (ie = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var ae = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), re(this, oe(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && ie(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M19 13v5c0 .55-.45 1-1 1H6c-.55 0-1-.45-1-1v-5c0-.55-.45-1-1-1s-1 .45-1 1v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6c0-.55-.45-1-1-1s-1 .45-1 1zm-6-.33l1.88-1.88c.39-.39 1.02-.39 1.41 0 .39.39.39 1.02 0 1.41l-3.59 3.59c-.39.39-1.02.39-1.41 0L7.7 12.2c-.39-.39-.39-1.02 0-1.41.39-.39 1.02-.39 1.41 0L11 12.67V4c0-.55.45-1 1-1s1 .45 1 1v8.67z"
        }));
      }
    }]) && ne(n.prototype, r), i && ne(n, i), t;
  }(o.a.PureComponent);

  function ce(e) {
    return (ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function se(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function ue(e, t) {
    return !t || "object" !== ce(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function le(e) {
    return (le = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function fe(e, t) {
    return (fe = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var pe = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), ue(this, le(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && fe(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/1999/xlink",
          width: "24",
          height: "24",
          viewBox: "0 0 200 200",
          preserveAspectRatio: "xMinYMin meet"
        }, o.a.createElement("defs", null, o.a.createElement("linearGradient", {
          id: "spinner-1552570621916",
          x1: "0%",
          y1: "0%",
          x2: "65%",
          y2: "0%"
        }, o.a.createElement("stop", {
          offset: "0%",
          className: "Spinner-blue-3_W"
        }), o.a.createElement("stop", {
          offset: "100%",
          stopOpacity: "0"
        }))), o.a.createElement("circle", {
          cx: "100",
          cy: "100",
          r: "90",
          fill: "transparent",
          stroke: "url(#spinner-1552570621916)",
          strokeWidth: "20"
        }));
      }
    }]) && se(n.prototype, r), i && se(n, i), t;
  }(o.a.PureComponent);

  function be(e) {
    return (be = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function me(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function ye(e, t) {
    return !t || "object" !== be(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function de(e) {
    return (de = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function he(e, t) {
    return (he = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var ge = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), ye(this, de(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && he(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M12 6v1.79c0 .45.54.67.85.35l2.79-2.79c.2-.2.2-.51 0-.71l-2.79-2.79c-.31-.31-.85-.09-.85.36V4c-4.42 0-8 3.58-8 8 0 1.04.2 2.04.57 2.95.27.67 1.13.85 1.64.34.27-.27.38-.68.23-1.04C6.15 13.56 6 12.79 6 12c0-3.31 2.69-6 6-6zm5.79 2.71c-.27.27-.38.69-.23 1.04.28.7.44 1.46.44 2.25 0 3.31-2.69 6-6 6v-1.79c0-.45-.54-.67-.85-.35l-2.79 2.79c-.2.2-.2.51 0 .71l2.79 2.79c.31.31.85.09.85-.35V20c4.42 0 8-3.58 8-8 0-1.04-.2-2.04-.57-2.95-.27-.67-1.13-.85-1.64-.34z"
        }));
      }
    }]) && me(n.prototype, r), i && me(n, i), t;
  }(o.a.PureComponent);

  function ve(e) {
    return (ve = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function we(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function _e(e, t) {
    return !t || "object" !== ve(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function Oe(e) {
    return (Oe = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function ze(e, t) {
    return (ze = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var ke = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), _e(this, Oe(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && ze(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M6.56 7.98C6.1 7.52 5.31 7.6 5 8.17c-.28.51-.5 1.03-.67 1.58-.19.63.31 1.25.96 1.25h.01c.43 0 .82-.28.94-.7.12-.4.28-.79.48-1.17.22-.37.15-.84-.16-1.15zM5.31 13h-.02c-.65 0-1.15.62-.96 1.25.16.54.38 1.07.66 1.58.31.57 1.11.66 1.57.2.3-.31.38-.77.17-1.15-.2-.37-.36-.76-.48-1.16-.12-.44-.51-.72-.94-.72zm2.85 6.02c.51.28 1.04.5 1.59.66.62.18 1.24-.32 1.24-.96v-.03c0-.43-.28-.82-.7-.94-.4-.12-.78-.28-1.15-.48-.38-.21-.86-.14-1.16.17l-.03.03c-.45.45-.36 1.24.21 1.55zM13 4.07v-.66c0-.89-1.08-1.34-1.71-.71L9.17 4.83c-.4.4-.4 1.04 0 1.43l2.13 2.08c.63.62 1.7.17 1.7-.72V6.09c2.84.48 5 2.94 5 5.91 0 2.73-1.82 5.02-4.32 5.75-.41.12-.68.51-.68.94v.02c0 .65.61 1.14 1.23.96C17.57 18.71 20 15.64 20 12c0-4.08-3.05-7.44-7-7.93z"
        }));
      }
    }]) && we(n.prototype, r), i && we(n, i), t;
  }(o.a.PureComponent);

  function je(e) {
    return (je = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Pe(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function xe(e, t) {
    return !t || "object" !== je(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function Se(e) {
    return (Se = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function Ee(e, t) {
    return (Ee = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var Te = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), xe(this, Se(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Ee(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M14.83 4.83L12.7 2.7c-.62-.62-1.7-.18-1.7.71v.66C7.06 4.56 4 7.92 4 12c0 3.64 2.43 6.71 5.77 7.68.62.18 1.23-.32 1.23-.96v-.03c0-.43-.27-.82-.68-.94C7.82 17.03 6 14.73 6 12c0-2.97 2.16-5.43 5-5.91v1.53c0 .89 1.07 1.33 1.7.71l2.13-2.08c.4-.38.4-1.02 0-1.42zm4.84 4.93c-.16-.55-.38-1.08-.66-1.59-.31-.57-1.1-.66-1.56-.2l-.01.01c-.31.31-.38.78-.17 1.16.2.37.36.76.48 1.16.12.42.51.7.94.7h.02c.65 0 1.15-.62.96-1.24zM13 18.68v.02c0 .65.62 1.14 1.24.96.55-.16 1.08-.38 1.59-.66.57-.31.66-1.1.2-1.56l-.02-.02c-.31-.31-.78-.38-1.16-.17-.37.21-.76.37-1.16.49-.41.12-.69.51-.69.94zm4.44-2.65c.46.46 1.25.37 1.56-.2.28-.51.5-1.04.67-1.59.18-.62-.31-1.24-.96-1.24h-.02c-.44 0-.82.28-.94.7-.12.4-.28.79-.48 1.17-.21.38-.13.86.17 1.16z"
        }));
      }
    }]) && Pe(n.prototype, r), i && Pe(n, i), t;
  }(o.a.PureComponent);

  function Ne(e) {
    return (Ne = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Ce(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Ie(e, t) {
    return !t || "object" !== Ne(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function Re(e) {
    return (Re = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function Le(e, t) {
    return (Le = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var De = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), Ie(this, Re(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Le(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        return o.a.createElement("svg", {
          xmlns: "http://www.w3.org/2000/svg",
          width: "24",
          height: "24",
          viewBox: "0 0 24 24"
        }, o.a.createElement("path", {
          fill: "none",
          d: "M0 0h24v24H0V0z"
        }), o.a.createElement("path", {
          d: "M6 14c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1H7v-2c0-.55-.45-1-1-1zm0-4c.55 0 1-.45 1-1V7h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm11 7h-2c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1s-1 .45-1 1v2zM14 6c0 .55.45 1 1 1h2v2c0 .55.45 1 1 1s1-.45 1-1V6c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1z"
        }));
      }
    }]) && Ce(n.prototype, r), i && Ce(n, i), t;
  }(o.a.PureComponent),
      Ve = Object(r.createContext)(),
      Be = n(9),
      Me = n.n(Be);

  function Ae(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function We(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Ae(Object(n), !0).forEach(function (t) {
        Fe(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ae(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function Fe(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var Ge = function Ge() {
    return document.body.scrollWidth;
  },
      He = function He() {
    return document.documentElement.clientWidth;
  },
      Ue = function Ue() {
    return window.innerHeight;
  },
      Ye = function Ye() {
    return document.documentElement.clientHeight;
  },
      Ke = {
    html: {},
    body: {}
  },
      Ze = function Ze() {
    document.documentElement.style.overflow = Ke.html.overflow, document.body.style.overflow = Ke.body.overflow, document.body.style.position = Ke.body.position;
  },
      Xe = function Xe(e, t) {
    var n;
    return n = setInterval(function () {
      e && !e.complete || (clearInterval(n), t && t());
    }, 500);
  },
      qe = function qe(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = Object.keys(t).reduce(function (e, n) {
      return t[n] ? e.concat("".concat(n, "=").concat(t[n])) : e;
    }, []).join("&");
    return n ? "".concat(e).concat(e.includes("?") ? "&" : "?").concat(n) : e;
  },
      Qe = Me()(function (e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        n = t.ref,
        r = void 0 === n ? 100 : n;
    return e ? e.includes("%") ? r * Number(e.substring(0, e.length - 1)) / 100 : Number(e.substring(0, e.length - 2)) : e;
  }),
      Je = Me()(function (e) {
    var t = ["Webkit", "Moz", "Ms", "O"];
    return Object.keys(e).reduce(function (n, r) {
      var o = t.reduce(function (t, n) {
        return We({}, t, Fe({}, "".concat(n).concat((o = r).charAt(0).toUpperCase() + o.slice(1)), e[r]));
        var o;
      }, {});
      return We({}, n, {}, o);
    }, e);
  }),
      $e = function $e(e) {
    return (0 ^ e) === e;
  },
      et = function et(e, t, n) {
    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {
      loop: !0
    };
    return 0 === t ? 0 : 0 === n ? e : e < 0 || e > t - 1 ? void 0 : r.loop ? Math.abs(t + n + e) % t : e + n < 0 || e + n > t - 1 ? void 0 : e + n;
  },
      tt = {
    0: [0],
    1: [-1, 0, 1],
    2: [-2, -1, 0, 1, 2],
    3: [-3, -2, -1, 0, 1, 2, 3]
  },
      nt = function nt(e) {
    return tt[e];
  };

  function rt(e) {
    return (rt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function ot(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function it(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function at(e, t) {
    return !t || "object" !== rt(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function ct(e) {
    return (ct = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function st(e, t) {
    return (st = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var ut = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), at(this, ct(t).apply(this, arguments));
    }

    var n, i, a;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && st(e, t);
    }(t, e), n = t, (i = [{
      key: "render",
      value: function value() {
        var e,
            t = this,
            n = this.context,
            i = n.set,
            a = (n.preset, n.presetIsMobile),
            c = (n.presetIsDesktop, n.controller),
            s = n.backdrop,
            u = n.loop,
            l = n.show,
            f = n.zoom,
            p = n.page,
            b = n.outBrowsing,
            m = n.toPage,
            y = n.toPrevPage,
            d = n.toNextPage,
            h = n.toggleZoom,
            g = n.toggleRotate;
        return o.a.createElement(r.Fragment, null, o.a.createElement("div", {
          id: "zmageControl",
          className: R()(D.a.controls, ot({}, D.a.show, !f && l)),
          style: {
            backgroundColor: s
          }
        }, c.rotate && o.a.createElement("div", {
          id: "zmageControlRotateLeft",
          className: R()(D.a.rotateLeft, ot({}, D.a.show, !f && l)),
          onClick: g("left")
        }, o.a.createElement(ke, null)), c.rotate && o.a.createElement("div", {
          id: "zmageControlRotateRight",
          className: R()(D.a.rotateRight, ot({}, D.a.show, !f && l)),
          onClick: g("right")
        }, o.a.createElement(Te, null)), c.download && o.a.createElement("div", {
          id: "zmageControlDownload",
          className: R()(D.a.download, ot({}, D.a.show, !f && l)),
          onClick: function onClick() {
            return e = t.context.set[t.context.page].src, (r = document.createElement("a")).href = e, r.download = n || e.split("/")[e.split("/").length - 1], document.body.appendChild(r), r.click(), void document.body.removeChild(r);
            var e, n, r;
          }
        }, o.a.createElement(ae, null)), c.zoom && o.a.createElement("div", {
          id: "zmageControlZoom",
          className: R()(D.a.zoom, ot({}, D.a.show, !f && l)),
          onClick: a ? function () {
            return window.open(i[p].src);
          } : h
        }, o.a.createElement(De, null)), c.close && o.a.createElement("div", {
          id: "zmageControlClose",
          className: R()(D.a.close, ot({}, D.a.show, !f && l)),
          onClick: f ? h : b
        }, o.a.createElement(ee, null))), Array.isArray(i) && i.length > 1 && c.flip && o.a.createElement(r.Fragment, null, (u || 0 !== p) && o.a.createElement("div", {
          id: "zmageControlFlipLeft",
          className: R()(D.a.flipLeft, ot({}, D.a.show, !f && l)),
          style: {
            backgroundColor: s
          },
          onClick: y
        }, o.a.createElement(F, null)), (u || p !== i.length - 1) && o.a.createElement("div", {
          id: "zmageControlFlipRight",
          className: R()(D.a.flipRight, ot({}, D.a.show, !f && l)),
          style: {
            backgroundColor: s
          },
          onClick: d
        }, o.a.createElement(Z, null))), Array.isArray(i) && i.length > 1 && c.pagination && o.a.createElement("div", {
          id: "zmageControlPagination",
          className: R()(D.a.pages, (e = {}, ot(e, D.a.show, !f && l), ot(e, D.a.mobile, a), e)),
          style: {
            backgroundColor: s
          }
        }, i.map(function (e, t) {
          return t === p ? o.a.createElement("span", {
            key: t,
            id: "zmageControlPaginationActive",
            className: D.a.blackDot
          }) : o.a.createElement("span", {
            key: t,
            className: D.a.whiteDot,
            onClick: function onClick() {
              return m(t);
            }
          });
        })));
      }
    }]) && it(n.prototype, i), a && it(n, a), t;
  }(o.a.PureComponent);

  ut.contextType = Ve;
  var lt = n(8),
      ft = n.n(lt),
      pt = n(6),
      bt = n.n(pt);

  function mt(e) {
    return (mt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function yt(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function dt(e, t) {
    return !t || "object" !== mt(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function ht(e) {
    return (ht = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function gt(e, t) {
    return (gt = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var vt = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), dt(this, ht(t).apply(this, arguments));
    }

    var n, i, a;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && gt(e, t);
    }(t, e), n = t, (i = [{
      key: "render",
      value: function value() {
        var e,
            t,
            n,
            i = this.props,
            a = i.show,
            c = i.load,
            s = i.invalidate,
            u = i.onReload,
            l = i.backdrop;
        return o.a.createElement(r.Fragment, null, (c || s) && o.a.createElement("div", {
          id: "zmageLoading",
          className: R()(bt.a.loadingContainer, (e = {}, t = bt.a.show, n = a, t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : e[t] = n, e))
        }, c && o.a.createElement("div", {
          className: bt.a.loading
        }, o.a.createElement(pe, null)), s && o.a.createElement("button", {
          className: bt.a.reload,
          onClick: u,
          style: {
            background: l
          }
        }, o.a.createElement(ge, null))));
      }
    }]) && yt(n.prototype, i), a && yt(n, a), t;
  }(o.a.PureComponent);

  vt.contextType = Ve;

  var wt = "cubic-bezier(0.60, 0.0, 0.10, 1.0)",
      _t = 350,
      Ot = function Ot() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 1;
    return "transform ".concat(_t * e, "ms ").concat(wt, ", opacity ").concat(_t * e, "ms ").concat(wt, ", clip-path ").concat(_t * e, "ms ").concat(wt);
  },
      zt = function zt(e, t, n, r) {
    var o = e.show,
        i = t.zoom;
    return o ? i ? Pt(e, t, n) : jt(e, t, n) : kt(e, t, n, r);
  },
      kt = function kt(e, t, n, r) {
    var o = t.coverRef,
        i = t.coverPos,
        a = t.rotate,
        c = t.pageIsCover;
    if (r && r.phase === Tt.END) return {
      _type: "cover",
      _behavior: "merge",
      y: r.getCurrentOffset().y > 0 ? Ue() : -Ue()
    };

    if (o.current) {
      var s = o.current.naturalWidth,
          u = o.current.getBoundingClientRect(),
          l = u.top,
          f = u.left,
          p = u.width,
          b = u.height,
          m = window.getComputedStyle(o.current),
          y = m.opacity,
          d = m.borderRadius;
      return c ? {
        _type: "cover",
        x: -Ge() / 2 + f + p / 2,
        y: -Ue() / 2 + l + b / 2,
        opacity: Number(y) || 1,
        scale: s ? p / s : 1,
        rotate: a - a % 360,
        radius: Qe(d, {
          ref: p
        })
      } : {
        _type: "cover",
        x: 0,
        y: -Ue(),
        opacity: 0,
        scale: s ? p / s : 1,
        rotate: a - a % 360,
        radius: Qe(d, {
          ref: p
        })
      };
    }

    return i ? {
      _type: "cover",
      x: i.x ? i.x - Ge() / 2 : 0,
      y: i.y ? i.y - Ue() / 2 : 0,
      opacity: 0,
      scale: 0,
      rotate: 0,
      radius: 0
    } : {
      _type: "cover",
      x: 0,
      y: 0,
      opacity: 0,
      scale: 0,
      rotate: 0,
      radius: 0
    };
  },
      jt = function jt(e, t, n) {
    var r = t.radius,
        o = t.edge,
        i = t.rotate,
        a = n.current;
    return {
      _type: "browsing",
      x: 0,
      y: 0,
      opacity: 1,
      scale: function (e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0,
            r = He(),
            o = Ye(),
            i = e + 2 * n,
            a = t + 2 * n,
            c = i > r ? r / (e + 2 * n) : 1,
            s = a > o ? o / (t + 2 * n) : 1;
        return Math.min(c, s) + .002;
      }(a.naturalWidth, a.naturalHeight, o),
      rotate: i,
      radius: r
    };
  },
      Pt = function Pt(e, t, n) {
    var r = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
        o = r.clientX,
        i = void 0 === o ? Ge() / 2 : o,
        a = r.clientY,
        c = void 0 === a ? Ue() / 2 : a,
        s = t.radius,
        u = t.edge,
        l = t.rotate,
        f = n.current,
        p = f.naturalWidth,
        b = f.naturalHeight,
        m = u || 50,
        y = Ge(),
        d = Ue(),
        h = p - y + 2 * m,
        g = b - d + 2 * m,
        v = p > y ? (p - y) / 2 + m - h * (i / y) : 0,
        w = b > d ? (b - d) / 2 + m - g * (c / d) : 0;
    return {
      _type: "zooming",
      x: v,
      y: w,
      opacity: 1,
      scale: 1,
      rotate: l,
      radius: s
    };
  },
      xt = function xt(e) {
    var t = 0,
        n = 0,
        r = 1;

    switch (e) {
      case "fade":
        r = 0;
        break;

      case "crossFade":
        t = 30, r = 0;
        break;

      case "swipe":
        t = Ge() + 10;
        break;

      case "zoom":
        n = .08, r = 0;
    }

    return {
      offset: t,
      overflow: n,
      opacity: r
    };
  },
      St = 120,
      Et = 80,
      Tt = {
    BEGIN: "BEGIN",
    MOVING: "MOVING",
    END: "END"
  },
      Nt = {
    SWIPING: "SWIPING",
    LIVING: "LIVING"
  },
      Ct = function Ct() {
    var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
        t = e.origin;
    return {
      updateCounter: 0,
      phase: Tt.BEGIN,
      behavior: void 0,
      begin: {
        time: new Date().getTime(),
        origin: t || {
          x: 0,
          y: 0
        },
        offset: {
          x: 0,
          y: 0
        }
      },
      current: {
        origin: t || {
          x: 0,
          y: 0
        },
        offset: {
          x: 0,
          y: 0
        }
      },
      getCurrentOffset: function getCurrentOffset() {
        return {
          x: this.current.origin.x - this.begin.origin.x,
          y: this.current.origin.y - this.begin.origin.y
        };
      },
      getCurrentDistance: function getCurrentDistance() {
        var e = this.getCurrentOffset();
        return {
          x: Math.abs(e.x),
          y: Math.abs(e.y)
        };
      },
      update: function update() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.origin;

        if (this.phase = Tt.MOVING, this.current.origin = t, !this.behavior) {
          var n = this.getCurrentDistance();
          n.x > n.y ? n.x > 5 && (this.behavior = Nt.SWIPING) : n.y > 5 && (this.behavior = Nt.LIVING);
        }

        return this;
      },
      end: function end() {
        this.phase = Tt.END;
        var e = new Date().getTime() - this.begin.time,
            t = this.getCurrentDistance();
        return (this.behavior === Nt.SWIPING && t.x / e < .35 && t.x < St || this.behavior === Nt.LIVING && t.y / e < .35 && t.y < Et) && (this.behavior = void 0), this;
      }
    };
  },
      It = function It(e) {
    var t,
        n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
        r = n.enableSwiping,
        o = n.enableLiving,
        i = {
      x: 0,
      y: 0
    };

    if (e && e.phase === Tt.MOVING) {
      var a = e.getCurrentOffset();
      e.behavior === Nt.SWIPING && r ? (i.x = a.x, t = "none") : e.behavior === Nt.LIVING && o && (i.y = a.y, t = "none");
    }

    return e && e.phase === Tt.END && (t = Ot(2)), {
      touch: i,
      transition: t
    };
  };

  function Rt(e) {
    return (Rt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Lt() {
    return (Lt = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function Dt(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function Vt(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Dt(Object(n), !0).forEach(function (t) {
        Ft(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Dt(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function Bt(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Mt(e) {
    return (Mt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function At(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function Wt(e, t) {
    return (Wt = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function Ft(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var Gt = function (e) {
    function t(e, n) {
      var r, i, a;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), i = this, a = Mt(t).call(this, e), r = !a || "object" !== Rt(a) && "function" != typeof a ? At(i) : a, Ft(At(r), "updateZoomEventListenerWithState", function () {
        var e = r.context,
            t = e.show,
            n = e.zoom;
        t && n && !r.listeningMouseMove ? (window.addEventListener("mousemove", r.handleMouseMove), r.listeningMouseMove = !0) : (window.removeEventListener("mousemove", r.handleMouseMove), r.listeningMouseMove = !1);
      }), Ft(At(r), "updateCurrentImageStyle", function () {
        var e = r.state.touchProfile,
            t = zt(r.props, r.context, r.imageRef, e);
        r.setCurrentStyle(t);
      }), Ft(At(r), "handleResize", function () {
        r.updateCurrentImageStyle();
      }), Ft(At(r), "handleScroll", function () {
        if (r.imageRef.current) {
          var e = r.context.show;
          r.imageRef.current.style.top = "calc(50% + ".concat(e ? 0 : r.initialPageOffset - window.pageYOffset, "px)");
        }
      }), Ft(At(r), "handleClick", function () {
        var e = r.context,
            t = e.zoom,
            n = e.toggleZoom;
        t && n();
      }), Ft(At(r), "handleTouchStart", function (e) {
        var t = e.touches[0],
            n = t.clientX,
            o = t.clientY;
        r.setTouchProfile(new Ct({
          origin: {
            x: n,
            y: o
          }
        }));
      }), Ft(At(r), "handleTouchMove", function (e) {
        var t = r.state.touchProfile,
            n = e.touches[0],
            o = n.clientX,
            i = n.clientY;
        r.setTouchProfile(t.update({
          origin: {
            x: o,
            y: i
          }
        }));
      }), Ft(At(r), "handleTouchEnd", function (e) {
        var t = r.state.touchProfile;
        r.setTouchProfile(t.end());
      }), Ft(At(r), "handleMouseMove", function (e) {
        var t = Pt(r.props, r.context, r.imageRef, e);
        r.setCurrentStyle(t);
      }), Ft(At(r), "handleImageLoadStart", function () {
        r.setState({
          isFetching: !0,
          invalidate: !1
        }, r.handleDetectImageLoadComplete);
      }), Ft(At(r), "handleDetectImageLoadComplete", function () {
        clearInterval(r.imageLoadingTimer), r.imageLoadingTimer = Xe(r.imageRef.current, r.handleImageLoadEnd);
      }), Ft(At(r), "handleImageLoadEnd", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.invalidate;
        clearInterval(r.imageLoadingTimer), r.setState({
          isFetching: !1,
          invalidate: void 0 === t ? r.state.invalidate : t
        });
      }), Ft(At(r), "handleImageLoad", function () {
        r.updateCurrentImageStyle();
      }), Ft(At(r), "handleImageError", function () {
        r.handleImageLoadEnd({
          invalidate: !0
        });
      }), Ft(At(r), "handleImageAbort", function () {
        r.handleImageLoadEnd({
          invalidate: !0
        });
      }), Ft(At(r), "handleImageReload", function () {
        var e = r.context.page;
        r.handleSetTimestamp(e);
      }), Ft(At(r), "handleSetTimestamp", function (e) {
        var t = r.context.set,
            n = r.state.timestamp;
        r.setState({
          timestamp: Vt({}, n, Ft({}, t[e].src, new Date().getTime()))
        });
      }), Ft(At(r), "handleGetTimestamp", function (e) {
        var t = r.context.set;
        return r.state.timestamp[t[e].src];
      }), Ft(At(r), "setCurrentStyle", function (e) {
        var t = r.context.animate,
            n = r.state.currentStyle;
        r.setState({
          currentStyle: "merge" === e._behavior ? Vt({}, n, {}, e) : e,
          animateConfig: xt(t.flip)
        });
      }), Ft(At(r), "setTouchProfile", function (e) {
        e && r.setState({
          touchProfile: Vt({}, e)
        }, function () {
          var e = r.context,
              t = e.outBrowsing,
              n = e.toPrevPage,
              o = e.toNextPage,
              i = r.state.touchProfile;
          i.phase === Tt.END && (i.behavior === Nt.SWIPING ? i.getCurrentOffset().x < 0 ? o() : n() : i.behavior === Nt.LIVING && t());
        });
      }), Ft(At(r), "getStyle", function (e, t, n) {
        var o,
            i,
            a,
            c = r.context,
            s = c.set,
            u = c.zoom,
            l = c.page,
            f = r.state,
            p = f.invalidate,
            b = f.currentStyle,
            m = f.touchProfile,
            y = f.animateConfig,
            d = y.offset,
            h = y.overflow,
            g = y.opacity,
            v = It(m, {
          enableSwiping: s.length > 1,
          enableLiving: !0
        }),
            w = v.touch,
            _ = v.transition;

        if (n) {
          var O = 1 === t ? b.x + w.x + d * e : b.x + d * e,
              z = b.y;
          o = "translate3d(-50%, -50%, 0) translate3d(".concat(O, "px, ").concat(z, "px, 0px) scale3d(").concat(b.scale + h, ", ").concat(b.scale + h, ", 1) rotate3d(0, 0, 1, 0deg)"), i = 10 * t, a = "none";
        } else {
          var k = b.x + w.x,
              j = b.y + w.y;
          o = "translate3d(-50%, -50%, 0) translate3d(".concat(k, "px, ").concat(j, "px, 0px) scale3d(").concat(b.scale, ", ").concat(b.scale, ", 1) rotate3d(0, 0, 1, ").concat(b.rotate, "deg)"), g = b.opacity, i = 10;
        }

        return Vt({}, Je({
          transform: o
        }), {
          cursor: u ? "zoom-out" : "initial",
          zIndex: i,
          opacity: p ? 0 : g,
          pointerEvents: a,
          transition: _
        }, s[l].style);
      }), Ft(At(r), "buildImageSeries", function (e) {
        var t = r.context,
            n = t.loop,
            o = t.set,
            i = t.page;
        return o.length > 1 ? nt(e).reduce(function (e, t) {
          var a = et(i, o.length, t, {
            loop: n
          });
          return $e(a) && e.push(r.buildImage({
            step: t,
            imageIndex: a
          })), e;
        }, []) : r.buildImage({
          step: 0,
          imageIndex: i
        });
      }), Ft(At(r), "buildImage", function () {
        var e,
            t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            n = t.step,
            i = t.imageIndex,
            a = r.context,
            c = a.set,
            s = a.show,
            u = a.zoom,
            l = a.page,
            f = a.pageWithStep,
            p = r.state.invalidate,
            b = Math.abs(n),
            m = b > 0,
            y = f + n,
            d = r.getStyle(n, b, m),
            h = R()(ft.a.imageLayer, c[i].className, (Ft(e = {}, ft.a.zooming, u), Ft(e, ft.a.invalidate, p), e)),
            g = {
          key: "".concat(y, "-").concat(c[i].src),
          style: d,
          className: h,
          src: qe(c[i].src, {
            t: r.handleGetTimestamp(l)
          }),
          alt: c[i].alt
        },
            v = {
          id: "zmageImage",
          ref: r.imageRef,
          onLoad: r.handleImageLoad,
          onError: r.handleImageError,
          onAbort: r.handleImageAbort,
          onClick: r.handleClick
        };

        if (m) {
          var w = s && !u;
          return w && o.a.createElement("img", g);
        }

        return o.a.createElement("img", Lt({}, g, v));
      }), r.imageRef = o.a.createRef(), r.initialPageOffset = window.pageYOffset, r.listeningMouseMove = !1, r.imageLoadingTimer = null, r.state = {
        isFetching: !0,
        invalidate: !1,
        currentStyle: kt(e, n),
        animateConfig: xt(n.animate.flip),
        touchProfile: new Ct(),
        timestamp: {}
      }, r;
    }

    var n, i, a;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Wt(e, t);
    }(t, e), n = t, (i = [{
      key: "componentDidMount",
      value: function value() {
        var e = this,
            t = this.context,
            n = t.presetIsMobile,
            r = t.presetIsDesktop;
        window.addEventListener("resize", this.handleResize), n && window.requestAnimationFrame(function () {
          window.addEventListener("touchstart", e.handleTouchStart), window.addEventListener("touchmove", e.handleTouchMove), window.addEventListener("touchend", e.handleTouchEnd);
        }), r && window.requestAnimationFrame(function () {
          window.addEventListener("scroll", e.handleScroll);
        });
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        var t = e.show,
            n = e.zoom,
            r = e.rotate,
            o = e.page,
            i = this.props,
            a = i.show,
            c = i.zoom,
            s = i.rotate,
            u = i.page,
            l = this.context.presetIsMobile;
        t === a && n === c && r === s || (t ? this.updateCurrentImageStyle() : (this.updateCurrentImageStyle(), this.handleDetectImageLoadComplete(), l && (Ke.html.overflow = document.documentElement.style.overflow, Ke.body.overflow = document.body.style.overflow, Ke.body.position = document.body.style.position, document.documentElement.style.overflow = "hidden", document.body.style.overflow = "hidden", document.body.style.position = "relative")), this.updateZoomEventListenerWithState()), o !== u && this.handleImageLoadStart();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        var e = this.context,
            t = e.presetIsMobile,
            n = e.presetIsDesktop;
        t && (window.removeEventListener("touchstart", this.handleTouchStart), window.removeEventListener("touchmove", this.handleTouchMove), window.removeEventListener("touchend", this.handleTouchEnd)), n && window.removeEventListener("scroll", this.handleScroll), window.removeEventListener("resize", this.handleResize), window.removeEventListener("mousemove", this.handleMouseMove), clearInterval(this.imageLoadingTimer);
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.context,
            t = (e.set, e.show),
            n = (e.zoom, e.page, e.pageIsCover),
            i = (e.pageWithStep, this.state),
            a = i.isFetching,
            c = i.invalidate;
        return o.a.createElement(r.Fragment, null, o.a.createElement(vt, {
          show: t && (!n || c),
          load: a,
          invalidate: c,
          onReload: this.handleImageReload
        }), this.buildImageSeries(2));
      }
    }]) && Bt(n.prototype, i), a && Bt(n, a), t;
  }(o.a.PureComponent);

  Gt.contextType = Ve;
  var Ht = n(11),
      Ut = n.n(Ht);

  function Yt(e) {
    return (Yt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Kt(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Zt(e, t) {
    return !t || "object" !== Yt(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function Xt(e) {
    return (Xt = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function qt(e, t) {
    return (qt = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var Qt = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), Zt(this, Xt(t).apply(this, arguments));
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && qt(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.show,
            n = e.zoom,
            r = this.context,
            i = r.backdrop,
            a = r.outBrowsing,
            c = r.toggleZoom,
            s = r.presetIsDesktop;
        return o.a.createElement("div", {
          id: "zmageBackground",
          className: Ut.a.backgroundLayer,
          onClick: n ? c : a,
          style: {
            opacity: t ? 1 : 0,
            background: i || "",
            transitionDelay: s ? t ? ".15s" : "0s" : t ? "0s" : ".35s"
          }
        });
      }
    }]) && Kt(n.prototype, r), i && Kt(n, i), t;
  }(o.a.Component);

  Qt.contextType = Ve;

  var Jt = function Jt(e, t, n) {
    return 0 === n || e && e.current && e.current.getAttribute("src") === t[n].src;
  },
      $t = function $t(e, t, n) {
    var r = function (e, t) {
      return $e(e) && e < t.length - 1 ? e : t.length - 1;
    }(t, n);

    return {
      page: r,
      pageIsCover: Jt(e, n, r)
    };
  },
      en = function en(e) {
    e && e.current && (e.current.style.visibility = "visible");
  },
      tn = function tn(e) {
    setTimeout(function () {
      e && e.current && (e.current.style.visibility = "hidden");
    }, 100);
  };

  function nn(e) {
    return (nn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function rn(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function on(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? rn(Object(n), !0).forEach(function (t) {
        ln(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : rn(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function an(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function cn(e) {
    return (cn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function sn(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function un(e, t) {
    return (un = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function ln(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var fn = function (e) {
    function t(e) {
      var n, r, o;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), r = this, o = cn(t).call(this, e), n = !o || "object" !== nn(o) && "function" != typeof o ? sn(r) : o, ln(sn(n), "getPropsWithEnv", function () {
        var e = n.props,
            t = e.preset,
            r = e.controller,
            o = e.hotKey,
            i = e.animate,
            a = j(t);
        return on({}, n.props, {
          presetIsMobile: "mobile" === t,
          presetIsDesktop: "mobile" !== t,
          controller: on({}, a.controller, {}, r),
          hotKey: on({}, a.hotKey, {}, o),
          animate: on({}, a.animate, {}, i)
        });
      }), ln(sn(n), "init", function () {
        var e = n.getPropsWithEnv(),
            t = e.isBrowsingControlled,
            r = e.coverRef,
            o = e.set,
            i = e.onBrowsing,
            a = e.hideOnScroll,
            c = e.coverVisible,
            s = e.presetIsDesktop,
            u = n.state,
            l = u.show,
            f = u.page,
            p = u.pageIsCover;
        l || (window.addEventListener("keydown", n.handleKeyDown), a && window.addEventListener("scroll", n.handleScroll), window.requestAnimationFrame(function () {
          n.setState({
            show: !0,
            zoom: !1,
            rotate: 0
          }, function () {
            s && p && !c && tn(r, o, f), !t && "function" == typeof i && i(!0);
          });
        }));
      }), ln(sn(n), "unInit", function () {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.force,
            r = n.getPropsWithEnv(),
            o = r.isBrowsingControlled,
            i = r.coverRef,
            a = r.set,
            c = r.onBrowsing,
            s = r.hideOnScroll,
            u = r.coverVisible,
            l = r.presetIsMobile,
            f = r.presetIsDesktop,
            p = n.state,
            b = p.show,
            m = p.page,
            y = p.pageIsCover;
        (b || t) && (window.removeEventListener("keydown", n.handleKeyDown), s && window.removeEventListener("scroll", n.handleScroll), !y && !u && en(i, a, m), n.setState({
          show: !1,
          zoom: !1,
          rotate: 0
        }, function () {
          return setTimeout(function () {
            n.setState({
              mounted: !1
            }, function () {
              l && Ze(), f && y && !u && en(i, a, m), !o && "function" == typeof c && c(!1);
            });
          }, f ? _t - 10 : 2 * _t - 10);
        }));
      }), ln(sn(n), "handleKeyDown", function (e) {
        var t = n.getPropsWithEnv(),
            r = t.set,
            o = t.hotKey,
            i = t.loop,
            a = t.outBrowsing,
            c = n.state,
            s = c.zoom,
            u = c.page;

        switch (e.keyCode) {
          case 27:
            e.preventDefault(), o.close && (s ? n.handleToggleZoom() : a());
            break;

          case 32:
            e.preventDefault(), o.zoom && n.handleToggleZoom();
            break;

          case 37:
            e.preventDefault(), (i || 0 !== u) && !s && o.flip && n.handleToPrevPage();
            break;

          case 39:
            e.preventDefault(), (i || u !== r.length - 1) && !s && o.flip && n.handleToNextPage();
            break;

          default:
            return;
        }
      }), ln(sn(n), "handleScroll", function () {
        var e = n.props.outBrowsing;
        n.state.show && e();
      }), ln(sn(n), "handleToPage", function (e) {
        var t = n.state.page;
        n.handleSwitchPages(e - t)();
      }), ln(sn(n), "handleSwitchPages", function (e) {
        var t = n.props,
            r = t.coverRef,
            o = t.onSwitching,
            i = t.loop;
        return function () {
          var t = n.props.set;

          if (t.length > 1) {
            var a = n.state,
                c = a.page,
                s = a.pageWithStep,
                u = et(c, t.length, e, {
              loop: i
            });
            "number" == typeof u && n.setState({
              page: u,
              pageIsCover: Jt(r, t, u),
              pageWithStep: s + e,
              zoom: !1,
              rotate: 0
            }, function () {
              "function" == typeof o && o(u);
            });
          }
        };
      }), ln(sn(n), "handleToPrevPage", n.handleSwitchPages(-1)), ln(sn(n), "handleToNextPage", n.handleSwitchPages(1)), ln(sn(n), "handleToggleZoom", function () {
        var e = n.props.onZooming;
        n.setState({
          zoom: !n.state.zoom
        }, function () {
          "function" == typeof e && e(n.state.zoom);
        });
      }), ln(sn(n), "handleToggleRotate", function (e) {
        var t = n.props.onRotating;

        switch (e) {
          case "left":
            return function () {
              return n.setState({
                rotate: n.state.rotate - 90
              }, function () {
                "function" == typeof t && t(n.state.rotate);
              });
            };

          case "right":
            return function () {
              return n.setState({
                rotate: n.state.rotate + 90
              }, function () {
                "function" == typeof t && t(n.state.rotate);
              });
            };

          default:
            return function () {
              return n.setState({
                rotate: 0
              }, function () {
                "function" == typeof t && t(0);
              });
            };
        }
      });
      var i = $t(e.coverRef, e.defaultPage, e.set),
          a = i.page,
          c = i.pageIsCover;
      return n.state = {
        mounted: !1,
        show: !1,
        zoom: !1,
        rotate: 0,
        page: a,
        pageIsCover: c,
        pageWithStep: a
      }, n;
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && un(e, t);
    }(t, e), n = t, i = [{
      key: "getDerivedStateFromProps",
      value: function value(e, t) {
        return e.browsing ? on({
          mounted: !0
        }, t.show ? {} : $t(e.coverRef, e.defaultPage, e.set)) : null;
      }
    }], (r = [{
      key: "componentDidMount",
      value: function value() {
        this.props.browsing && this.init();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e) {
        e.browsing !== this.props.browsing && (this.props.browsing ? this.init() : this.unInit());
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        this.unInit({
          force: !0
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.getPropsWithEnv(),
            t = e.coverRef,
            n = e.coverPos,
            r = e.outBrowsing,
            i = e.set,
            a = e.preset,
            c = e.presetIsMobile,
            u = e.presetIsDesktop,
            l = e.controller,
            f = e.hotKey,
            p = e.animate,
            b = e.hideOnScroll,
            m = e.coverVisible,
            y = e.backdrop,
            d = e.zIndex,
            h = e.radius,
            g = e.edge,
            v = e.loop,
            w = this.state,
            _ = w.mounted,
            O = {
          show: w.show,
          zoom: w.zoom,
          rotate: w.rotate,
          page: w.page,
          pageIsCover: w.pageIsCover,
          pageWithStep: w.pageWithStep
        },
            z = on({
          coverRef: t,
          coverPos: n,
          outBrowsing: r,
          set: i,
          preset: a,
          presetIsMobile: c,
          presetIsDesktop: u,
          controller: l,
          hotKey: f,
          animate: p,
          hideOnScroll: b,
          coverVisible: m,
          backdrop: y,
          radius: h,
          edge: g,
          loop: v
        }, O, {
          toPage: this.handleToPage,
          toPrevPage: this.handleToPrevPage,
          toNextPage: this.handleToNextPage,
          toggleZoom: this.handleToggleZoom,
          toggleRotate: this.handleToggleRotate
        });
        return o.a.createElement(Ve.Provider, {
          value: z
        }, _ && o.a.createElement(C, {
          id: "zmage",
          zIndex: d,
          className: s.a.wrapperLayer
        }, o.a.createElement(Qt, O), o.a.createElement(ut, O), o.a.createElement(Gt, O)));
      }
    }]) && an(n.prototype, r), i && an(n, i), t;
  }(o.a.PureComponent);

  function pn(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function bn(e) {
    return (bn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function mn() {
    return (mn = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function yn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function dn(e) {
    return (dn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function hn(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function gn(e, t) {
    return (gn = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  fn.contextType = Ve, fn.defaultProps = {
    isBrowsingControlled: !1,
    browsing: !1,
    coverRef: o.a.createRef(),
    outBrowsing: function outBrowsing() {},
    defaultPage: 0,
    set: []
  };
  var vn = {
    x: 0,
    y: 0
  },
      wn = {
    x: 0,
    y: 0
  };
  "undefined" != typeof window && window.document && window.document.documentElement && document.documentElement.addEventListener("click", function (e) {
    wn = {
      x: e.clientX,
      y: e.clientY
    }, setTimeout(function () {
      return wn = {
        x: 0,
        y: 0
      };
    }, 100);
  });

  var _n = function (e) {
    function t(e) {
      var n, r, o, i, a, c;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), r = this, o = dn(t).call(this, e), n = !o || "object" !== bn(o) && "function" != typeof o ? hn(r) : o, i = hn(n), c = function c() {
        var e = n.props.destroyer;
        n.setState({
          browsing: !1
        }), setTimeout(e, _t);
      }, (a = "outBrowsing") in i ? Object.defineProperty(i, a, {
        value: c,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : i[a] = c, n.state = {
        browsing: !0
      }, vn = wn, n;
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && gn(e, t);
    }(t, e), n = t, (r = [{
      key: "render",
      value: function value() {
        var e = P(this.props),
            t = e.calleeProps,
            n = e.configProps,
            r = this.state.browsing,
            i = t.coverRef ? {
          coverRef: t.coverRef
        } : {
          coverPos: r ? wn : vn
        };
        return o.a.createElement(fn, mn({
          browsing: r
        }, i, {
          outBrowsing: this.outBrowsing
        }, n));
      }
    }]) && yn(n.prototype, r), i && yn(n, i), t;
  }(o.a.PureComponent);

  _n.propTypes = v, _n.defaultProps = w;

  var On = {
    REF: o.a.createRef(),
    CONTAINER: null,
    PORTAL: null
  },
      zn = function zn(e) {
    var t = e.coverRef,
        n = pn(e, ["coverRef"]);
    return On.PORTAL = document.createElement("div"), On.PORTAL.id = "zmagePortal", On.CONTAINER = document.body, On.CONTAINER.appendChild(On.PORTAL), a.a.render(o.a.createElement(_n, mn({
      ref: On.REF,
      coverRef: t,
      destroyer: function destroyer() {
        return On.CONTAINER.removeChild(On.PORTAL);
      }
    }, n)), On.PORTAL), On.REF.current.outBrowsing;
  };

  function kn(e) {
    return (kn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function jn(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function Pn(e, t) {
    if (null == e) return {};

    var n,
        r,
        o = function (e, t) {
      if (null == e) return {};
      var n,
          r,
          o = {},
          i = Object.keys(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
      }

      return o;
    }(e, t);

    if (Object.getOwnPropertySymbols) {
      var i = Object.getOwnPropertySymbols(e);

      for (r = 0; r < i.length; r++) {
        n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
      }
    }

    return o;
  }

  function xn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Sn(e) {
    return (Sn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function En(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function Tn(e, t) {
    return (Tn = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function Nn(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var Cn = function (e) {
    function t(e) {
      var n, r, i;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), r = this, i = Sn(t).call(this, e), n = !i || "object" !== kn(i) && "function" != typeof i ? En(r) : i, Nn(En(n), "attachBrowserToImage", function () {
        var e = n.props,
            t = (e.children, Pn(e, ["children"]));
        n.contentRef.current && n.contentRef.current.querySelectorAll("img").forEach(function (e) {
          !e.getAttribute("zmage") && e.getAttribute("src") && (e.style.cursor = "zoom-in", e.setAttribute("zmage", Date.now()), e.addEventListener("click", function () {
            return zn(function (e) {
              for (var t = 1; t < arguments.length; t++) {
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? jn(Object(n), !0).forEach(function (t) {
                  Nn(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : jn(Object(n)).forEach(function (t) {
                  Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
              }

              return e;
            }({}, t, {
              coverRef: {
                current: e
              },
              src: e.getAttribute("src")
            }));
          }));
        });
      }), n.contentRef = o.a.createRef(), n;
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Tn(e, t);
    }(t, e), n = t, (r = [{
      key: "componentDidMount",
      value: function value() {
        window.__ZMAGE_BROWSER__ = zn, this.attachBrowserToImage();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t, n) {
        this.attachBrowserToImage();
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props.children;
        return o.a.createElement("div", {
          ref: this.contentRef
        }, e);
      }
    }]) && xn(n.prototype, r), i && xn(n, i), t;
  }(o.a.PureComponent);

  Cn.propTypes = v, Cn.defaultProps = w;
  var In = Cn;

  function Rn(e) {
    return (Rn = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function Ln() {
    return (Ln = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function Dn(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function Vn(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? Dn(Object(n), !0).forEach(function (t) {
        Fn(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Dn(Object(n)).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function Bn(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function Mn(e) {
    return (Mn = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function An(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function Wn(e, t) {
    return (Wn = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function Fn(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  var Gn = function (e) {
    function t(e) {
      var n, r, i;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), r = this, i = Mn(t).call(this, e), n = !i || "object" !== Rn(i) && "function" != typeof i ? An(r) : i, Fn(An(n), "inBrowsing", function () {
        n.isBrowsingControlled ? n.props.onBrowsing(!0) : n.setState({
          browsing: !0
        });
      }), Fn(An(n), "outBrowsing", function () {
        n.isBrowsingControlled ? n.props.onBrowsing(!1) : n.setState({
          browsing: !1
        });
      }), n.coverRef = o.a.createRef(), n.isBrowsingControlled = n.props.hasOwnProperty("browsing"), n.state = {
        browsing: !1
      }, n;
    }

    var n, i, a;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && Wn(e, t);
    }(t, e), n = t, (i = [{
      key: "render",
      value: function value() {
        var e = this,
            t = P(this.props),
            n = t.coverProps,
            i = t.stateProps,
            a = t.configProps,
            c = t.restProps,
            s = this.state.browsing;
        return o.a.createElement(r.Fragment, null, o.a.createElement("img", Ln({
          className: n.className,
          style: Vn({
            cursor: "zoom-in"
          }, n.style),
          src: n.src,
          alt: n.alt,
          onClick: function onClick(t) {
            e.inBrowsing(), "function" == typeof n.onClick && n.onClick(t);
          },
          ref: function ref(t) {
            n.forwardedRef && (n.forwardedRef.current = t), e.coverRef && (e.coverRef.current = t);
          }
        }, c)), o.a.createElement(fn, Ln({
          isBrowsingControlled: this.isBrowsingControlled,
          browsing: this.isBrowsingControlled ? i.controlledBrowsing : s,
          coverRef: this.coverRef,
          outBrowsing: this.outBrowsing
        }, a)));
      }
    }]) && Bn(n.prototype, i), a && Bn(n, a), t;
  }(o.a.PureComponent);

  Gn.propTypes = v, Gn.defaultProps = w;
  var Hn = o.a.forwardRef(function (e, t) {
    return o.a.createElement(Gn, Ln({}, e, {
      forwardedRef: t
    }));
  });
  Hn.browsing = zn, Hn.Browsing = zn, Hn.wrapper = In, Hn.Wrapper = In;
  var Un = Hn;
  n.d(t, "default", function () {
    return Un;
  });
}]);